@if (isUserLoggedIn) {
  <ep-user-sticker></ep-user-sticker>
  <ediportal-mainmenu #mainMenu></ediportal-mainmenu>
}

<div id="main-content" (click)="onClick()">
  <div class="container-fluid">
    <!-- breadcrumb component -->
    @if (isUserLoggedIn) {
      <breadcrumb />
    }
    <!-- end breadcrumb component -->
    <router-outlet />
  </div>
</div>

<!-- Needed for the modal-service to work -->
<ng-template ngbModalContainer>
</ng-template>

<!-- Different generic components -->
<ep-generic-modal-message />
<ep-toast />
<ep-loading-panel />
<app-global-notification-panel />
